var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.componentType)?_c('div',[_vm._v("\n    Error: component not found\n  ")]):_c(_vm.componentType,{tag:"component",attrs:{"error":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }